/**
 * @description
 * Employee Loan Company headers
 * 
 * @type       {array}
 */
export default [
    {
        text: '#',
        value: 'id',
        sortable: true,
        width: '5%',
    },
    {
        text: 'folio',
        value: 'debit_note_number',
        sortable: true,
        width: '5%',
    },
    {
        text: 'proveedor',
        value: 'pch_provider_business_name',
        width: '25%',
    },
    {
        text: 'factura',
        value: 'invoice_number',
        sortable: true,
        width: '5%',
    },
    {
        text: 'nota credito',
        value: 'credit_note_number',
        sortable: true,
        width: '5%',
    },
    {
        text: 'condicion',
        value: 'pch_payment_condition_type',
        align: 'center',
        component: {
            type: 'chip-label',
            props: {
                small: true,
            },
        },
    },
    {
        text: 'cancelada',
        value: 'was_canceled',
        format: 'boolean',
        align: 'center',
    },
    {
        text: 'pago',
        value: 'payment_date',
        align: 'right',
        format: 'date',
    },
    {
        text: 'emision',
        value: 'created_at',
        align: 'right',
        format: 'date',
    },
]
